const courses_en = require('./courses.json')
export default courses_en